// A destruction-time geometry snapshot, not material mass or a solid-volume measurement.
export function normalizeRubbleSource(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)
    || value.schema !== 'ft.rubble-source.v1'
    || !['mesh-bounds', 'wall-section'].includes(value.basis)) return null;
  const out = {schema: 'ft.rubble-source.v1', basis: value.basis};
  for (const key of ['heightM', 'footprintM', 'volumeM3']) {
    if (key === 'volumeM3' && value[key] === undefined) continue;
    const n = value[key];
    if (typeof n !== 'number' || !Number.isFinite(n) || n < .000001 || n > (key === 'volumeM3' ? 1e9 : 1000)) return null;
    out[key] = Math.round(n * 1e6) / 1e6;
  }
  return out;
}

export function rubbleSourceFromBounds(bounds) {
  if (!Array.isArray(bounds) || bounds.length !== 3 || !bounds.every(n => typeof n === 'number' && Number.isFinite(n) && n > 0)) return null;
  return normalizeRubbleSource({schema: 'ft.rubble-source.v1', basis: 'mesh-bounds',
    heightM: bounds[1], footprintM: Math.max(bounds[0], bounds[2]), volumeM3: bounds[0] * bounds[1] * bounds[2]});
}
